// extracted by mini-css-extract-plugin
var _1 = "LabelsStep_addButton__vxcSF";
var _2 = "LabelsStep_inputWrapper__M0cR-";
var _3 = "LabelsStep_items__cZWCM";
export { _1 as "addButton", _2 as "inputWrapper", _3 as "items" }
